<template>
    <div data-aos="fade-up" data-aos-offset="300" data-aos-delay="200" data-aos-duration="600" class="partner-slide">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <template v-for="(partner, index) in partners">
                    <div class="swiper-slide" :key="index">
                        <router-link v-if="!partner.isOuterLink" class="partner-slide__box" :to="partner.url">
                            <div class="partner-slide__thumb"><img :src="partner.image" :alt="partner.name" /></div>
                        </router-link>
                        <a v-else class="partner-slide__box" :href="partner.url">
                            <div class="partner-slide__thumb"><img :src="partner.image" :alt="partner.name" /></div>
                        </a>
                    </div>
                </template>
                <!-- <template v-for="(item, index) in items">
                    <div class="swiper-slide" :key="index">
                        <router-link class="partner-slide__box" :to="item.to">
                            <div class="partner-slide__thumb"><img :src="item.src" :alt="item.name" /></div>
                        </router-link>
                    </div>
                </template> -->
            </div>
            <div class="buttons">
                <button class="prev" type="button"></button>
                <button class="next" type="button"></button>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/api";
export default {
    mounted() {
        this.search();
        this.$nextTick(() => {
            setTimeout(() => {
                var partnerSlide = new window.Swiper(".partner-slide .swiper-container", {
                    slidesPerView: "auto",
                    spaceBetween: 18,
                    speed: 500,
                    loop: true,
                    autoplay: {
                        delay: 1000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: ".partner-slide .next",
                        prevEl: ".partner-slide .prev",
                    },
                });
            }, 1000);
        });
    },
    data: () => ({
        items: [
            {
                name: "플레이스테이션",
                to: "/gshop/brand/giftcards?_category=&_brand=642fcb2612e7ac0e0768a0a7",
                src: "/images/main/partners/1.png",
            },
            {
                name: "씨유",
                to: "/gshop/brand/giftcards?_category=&_brand=642fc619905c7ffe4984c81a",
                src: "/images/main/partners/2.png",
            },
            // {
            //     name: "에쓰오일",
            //     to: "/gshop/brand/giftcards?_category=&_brand=642fc504b8991421a2e6dd65",
            //     src: "/images/main/partners/3.png",
            // },
            {
                name: "구글 플레이",
                to: "/gshop/brand/giftcards?_category=&_brand=642fcb797e6592feee0634eb",
                src: "/images/main/partners/4.png",
            },
            {
                name: "맥도날드",
                to: "/gshop/brand/giftcards?_category=&_brand=642fc8859b9218266ff60098",
                src: "/images/main/partners/5.png",
            },
            {
                name: "아프리카티브이",
                to: "/gshop/brand/giftcards?_category=&_brand=642fcb6a905c7ffe4984ca35",
                src: "/images/main/partners/7.png",
            },
            {
                name: "신세계",
                to: "/gshop/brand/giftcards?_category=&_brand=642f9decf75800bb403e5d0e",
                src: "/images/main/partners/8.png",
            },
            // {
            //     name: "이디야 커피",
            //     to: "/gshop/brand/giftcards?_category=&_brand=642fc9aeb8991421a2e6dece",
            //     src: "/images/main/partners/9.png",
            // },
            {
                name: "컬쳐랜드",
                to: "/gshop/brand/giftcards?_category=&_brand=642fc0b259fe35638ff897f1",
                src: "/images/main/partners/10.png",
            },
            // {
            //     name: "스타벅스",
            //     to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=66baefd892294932070c18a8",
            //     src: "/images/main/partners/11.png",
            // },
            // {
            //     name: "티머니",
            //     to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=662b3b8e54983e092df2ef6c",
            //     src: "/images/main/partners/12.png",
            // },
            // {
            //     name: "해피머니",
            //     to: "/gshop/brand/giftcards?_category=614c2775f03c89649c9e0008&_brand=6620cbf43f528d102c8885ad",
            //     src: "/images/main/partners/13.png",
            // },
            // {
            //     name: "넥슨",
            //     to: "/gshop/brand/giftcards?_category=614c280ff03c89649c9e000a&_brand=662b39f06638178e2e3da086",
            //     src: "/images/main/partners/14.png",
            // },
            {
                name: "도서문화상품권",
                to: "/gshop/brand/giftcards?_category=614c2775f03c89649c9e0008&_brand=661f21de336dae1a6adb7c78",
                src: "/images/main/partners/15.png",
            },
            {
                name: "빽다방",
                to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=665d83e56e7d0b0fd69b568d",
                src: "/images/main/partners/16.png",
            },
            {
                name: "홍콩반점",
                to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=665d844a93654d154799b7aa",
                src: "/images/main/partners/17.png",
            },
            // {
            //     name: "셀렉토커피",
            //     to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=665d8470589ed83ac6b4e720",
            //     src: "/images/main/partners/18.png",
            // },
            // {
            //     name: "롯데마트",
            //     to: "/gshop/brand/giftcards?_category=614c2775f03c89649c9e0008&_brand=66a060dcf6d8e9b92d944081",
            //     src: "/images/main/partners/19.png",
            // },
            // {
            //     name: "이마트24",
            //     to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=64f92b04c3a1ff6c3724c376",
            //     src: "/images/main/partners/20.png",
            // },
            // {
            //     name: "뚜레쥬르",
            //     to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc94c9b9218266ff600ef",
            //     src: "/images/main/partners/21.png",
            // },
            // {
            //     name: "설빙",
            //     to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc84ac81f00869b9c6e97",
            //     src: "/images/main/partners/22.png",
            // },
            {
                name: "현대백화점",
                to: "/gshop/brand/giftcards?_category=614c2775f03c89649c9e0008&_brand=642fa76c59fe35638ff894fc",
                src: "/images/main/partners/23.png",
            },
            {
                name: "굽네치킨",
                to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc8cc12e7ac0e07689fcb",
                src: "/images/main/partners/24.png",
            },
            // {
            //     name: "아웃백",
            //     to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc8e2b01b51471bba74d6",
            //     src: "/images/main/partners/25.png",
            // },
            {
                name: "홈플러스",
                to: "/gshop/brand/giftcards?_category=614c2775f03c89649c9e0008&_brand=642fc383e3ede0326811ae9c",
                src: "/images/main/partners/26.png",
            },
            {
                name: "지니",
                to: "/gshop/brand/giftcards?_category=614c280ff03c89649c9e000a&_brand=642fcb1412bc4e767b2a83d1",
                src: "/images/main/partners/27.png",
            },
            {
                name: "공차",
                to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc96db8991421a2e6dec5",
                src: "/images/main/partners/28.png",
            },
            {
                name: "도미노",
                to: "/gshop/brand/giftcards?_category=614c281df03c89649c9e000b&_brand=642fc91eb01b51471bba74e9",
                src: "/images/main/partners/29.png",
            },
            {
                name: "네이버페이",
                to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=672d7d543eddfe1844e1f031",
                src: "/images/main/partners/30.png",
            },
            {
                name: "다이소",
                to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=672d7d614ce03f2c492f0236",
                src: "/images/main/partners/31.png",
            },
            {
                name: "배달의 민족",
                to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=672d7d9c27bc8a8cc56a038f",
                src: "/images/main/partners/32.png",
            },
            {
                name: "올리브영",
                to: "/gshop/brand/giftcards?_category=614c283af03c89649c9e000c&_brand=672d7dc84ce03f2c492f0275",
                src: "/images/main/partners/33.png",
            },
        ],
        partners: [],
    }),
    methods: {
        async search() {
            try {
                let { partners, summary } = await api.v1.common.partners.gets({ params: { shows: true } });

                this.partners = partners;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>


<style scoped>
.partner-slide {
    position: relative;
}
.partner-slide .swiper-container {
    overflow: visible;
}
.partner-slide .swiper-slide {
    width: auto;
}
.partner-slide .buttons {
    display: none;
}
.partner-slide .buttons button {
    margin-left: -1px;
    width: 45px;
    height: 45px;
    border: 1px solid #dddddd;
    background-repeat: no-repeat;
    background-position: center;
}
.partner-slide .buttons button:hover {
    background-color: #aeaeae;
}
.partner-slide .buttons .prev {
    background-image: url("/images/icon/prev.png");
}
.partner-slide .buttons .prev:hover {
    background-image: url("/images/icon/prev-light.png");
}
.partner-slide .buttons .next {
    background-image: url("/images/icon/next.png");
}
.partner-slide .buttons .next:hover {
    background-image: url("/images/icon/next-light.png");
}
.partner-slide__box {
    overflow: hidden;
    display: block;
    position: relative;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0px 7px 20px 0px rgba(0, 0, 0, 0.1);
}
.partner-slide__thumb {
    width: 120px;
    height: 120px;
}
.partner-slide__thumb::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #1a284d;
    opacity: 0;
    -webkit-transition: all ease 0.15s;
    transition: all ease 0.15s;
}
.partner-slide__thumb img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
}
.partner-slide__box:hover .partner-slide__thumb::after {
    opacity: 0.5;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .partner-slide .buttons {
        display: flex;
        position: absolute;
        top: -108px;
        right: calc(50vw - 600px);
    }
    /* .partner-slide__thumb { width: 180px; height: 180px; } */
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>